export const supportsSafariOnly = (styles: string) => {
  return `
        @supports (-webkit-hyphens: auto) {
        ${styles}
        }
    `;
};
